// extracted by mini-css-extract-plugin
export default {"fullWidth":"go-z","image":"ho-z","lazyLoadPicture":"io-z","lazyLoadSpinner":"jo-z","lazyLoadSpin":"ko-z","lazyLoadImage":"lo-z","hasStyledAspectRatio":"mo-z"};